import { TagTemplate } from "../features/user/types";

const ENTITY = "tagTemplates";

export const getTagTemplates = (state: { [key: string]: any }) =>
  state.entities[ENTITY].tagTemplates as TagTemplate[];
